import * as React from 'react';

function AnalystRecommendations({data} :any) {
  return (
    <div className="col-lg-4 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Analyst Recommendations</h4>
          <div className="table-responsive">
            <table className="table table-striped">
              <tbody>
                <tr>
                  <td>No. of analysts</td>
                  <td>{data.analyst_recommendations[0]?.analystCount}</td>
                </tr>
                <tr>
                  <td>Consensus date</td>
                  <td>{data.analyst_recommendations[0]?.consensusDate}</td>
                </tr>
                <tr>
                  <td>Market price</td>
                  <td>
                    {data.estimated_valuation?.price_in_words}
                  </td>
                </tr>
                <tr>
                  <td>Target price</td>
                  <td>
                    <span className={ (data.analyst_recommendations[0]?.marketConsensusTargetPrice > data.latest_price) ? 'badge-success badge-pill' : 'badge-danger badge-pill' }>
                      {data.analyst_recommendations[0]?.market_consensus_target_price_in_words}
                    </span>
                   </td>
                </tr>
                <tr>
                  <td>Recommendation</td>
                  <td>
                    <span className={ data.analyst_recommendations[0]?.consensus_ratings_color }>{data.analyst_recommendations[0]?.consensus_ratings}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AnalystRecommendations;
